/**
 * PrivZap Admin product identity.
 * Host branding still reads REACT_APP_NAME from env — set it to this name.
 */
export const APP_NAME = 'PrivZap Admin'
export const APP_TITLE = 'PrivZap Admin'

export default {
  name: APP_NAME,
  title: APP_TITLE,
}
